import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    value: [],
    allPrompts: [],
    displayCount: 10
}

const guidePromptsSlice = createSlice({
    name: 'guidePrompts',
    initialState,
    reducers: {
        setPromptsFiltered: (state, action) => {
            state.value = action.payload
            state.allPrompts = action.payload
            state.displayCount = 10
        },
        loadMorePrompts: (state) => {
            state.displayCount += 10
        },
        resetDisplayCount: (state) => {
            state.displayCount = 10
        }
    }
})

export const { setPromptsFiltered, loadMorePrompts, resetDisplayCount } = guidePromptsSlice.actions;
export default guidePromptsSlice.reducer